module.exports = __webpack_public_path__ + "img/lock-pdf.812ec98d.svg";